import { useNavigate } from "react-router-dom";
import { Button } from "../components/misc/Button";
import SocialConnections from "../components/settings/Connections/SocialConnections";
import { handleLogoutGenerator } from "../global-actions/handleLogout";
import { auth } from "../firebase/firebase-config";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

const ConnectSocialsScreen = () => {
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.auth.user);

    return (
        <div className="relative w-full h-full flex flex-col items-center justify-center">
            <div className="flex flex-row justify-end items-center w-full p-4">
                <Button
                    id="back-to-settings-btn"
                    onClick={handleLogoutGenerator(auth, navigate, user)}
                    className="mb-4 flex items-center"
                    variant="destructive"
                >
                    Logout
                </Button>
            </div>
            <SocialConnections isOnboarding={true} />
        </div>
    );
};
export default ConnectSocialsScreen;
